import { FC, RefObject } from 'react';
import { Category, Headline } from '~/lib/data-contract';
import { Carousel } from '~/shared/components/Carousel';
import { CardCategory } from '../CardCategory/CardCategory';
import { weakKey } from '~/shared/utils/jsx';
import { Button } from '~/shared/components';
import ChevronLeft from '~/icons/chevron-left.svg';
import ChevronRight from '~/icons/chevron.svg';
import { Text } from '~/shared/components';
import { useGetCarouselOptions } from '~/templates/blocks/hooks/useGetCarouselOptions';
import styles from './CardCarousel.module.scss';

export type CarouselProps = {
    items: Category[];
    priority?: boolean;
    leftArrow?: RefObject<HTMLButtonElement>;
    rightArrow?: RefObject<HTMLButtonElement>;
    headline?: Headline;
    textColor?: string;
};

const CategoryCarousel: FC<CarouselProps> = (props: CarouselProps) => {
    const { items, priority, leftArrow, rightArrow, headline, textColor } = props;
    const { shouldShowButtons, desktop, tablet, getCarouselOptions } = useGetCarouselOptions(items);

    return (
        <div className={styles.cardCarouselContainer}>
            {headline?.text && (
                <div className={styles.cardCarouselheadline}>
                    <Text
                        as={headline?.tag}
                        variant={headline?.style}
                        children={headline?.text}
                        color={headline?.textColor || textColor}
                        data-testid="StyledHeadline"
                    />
                </div>
            )}

            {shouldShowButtons && (
                <Button className={styles.cardCarouselLeft} variant="icon" ref={leftArrow}>
                    <ChevronLeft />
                </Button>
            )}
            <Carousel
                options={getCarouselOptions()}
                prevRef={leftArrow}
                nextRef={rightArrow}
                items={items.map((item) => (
                    <CardCategory
                        desktopAspectRatio={desktop.aspectRatio}
                        tabletAspectRatio={tablet.aspectRatio}
                        noPadding={true}
                        priority={priority}
                        key={weakKey(item)}
                        item={item}
                    />
                ))}
            />
            {shouldShowButtons && (
                <Button className={styles.cardCarouselRight} variant="icon" ref={rightArrow}>
                    <ChevronRight />
                </Button>
            )}
        </div>
    );
};

export default CategoryCarousel;
